import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Card, Spinner } from "react-bootstrap";
import {
    IconCloudUp,
    IconFileText,
    IconArrowRight,
} from "@tabler/icons-react";
import moment from "moment";
import { toast } from "react-toastify";
import { API_ENDPOINTS } from "../../../constant/_constant";
import usePostRequest from "../../../hooks/usePostRequest";
import { useFormContext, Controller, } from "react-hook-form";
import { trimTrailingZeros } from "../../../utils/_helpers";
function GsaPdfModal({ show, setShow }) {
    const fileInputRef = useRef(null);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isDragging, setIsDragging] = useState(false);

    const { isLoading: uploading, postData: uploadPdf } = usePostRequest(
        API_ENDPOINTS.GSA_PDF
    );

    const handleClose = () => {
        setShow({ show: false });
        setSelectedFiles([]);
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const handleBrowseClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files || []);
        addFiles(files);
    };


    const addFiles = (files) => {
        if (!files.length) return;

        const file = files[0];
        const isPdf = file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");

        if (!isPdf) {
            toast.error("Only PDF files are supported.");
            return;
        }

        if (file.size > 20 * 1024 * 1024) {
            toast.error("File size must be under 20MB.");
            return;
        }

        setSelectedFiles([file]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
        const files = Array.from(e.dataTransfer.files || []);
        addFiles(files);
    };

    const handleClearAll = () => {
        setSelectedFiles([]);
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const generateUniqueId10 = () => {
    const array = new Uint8Array(8);
    crypto.getRandomValues(array);
    const id = btoa(String.fromCharCode(...array))
        .replace(/[^a-zA-Z0-9]/g, "")
        .slice(0, 10);
    return id;
};


    const onSuccessUpload = (res) => {
        toast.success(res?.message || "File uploaded successfully!");
        setSelectedFiles([]);
        if (fileInputRef.current) fileInputRef.current.value = "";
        handleClose();
        console.log("res?.data", res?.data)
        if (res?.data) {
            const d = res.data;

            setValue("ordertype", d?.order_type || "");
            setValue("orderId", d?.order_id || "");
            setValue(
                "publishedDate",
                d?.published_date ? moment(d.published_date).format("MM/DD/YYYY") : null
            );
            setValue(
                "payment_terms",
                res?.data?.payment_terms ? res?.data?.payment_terms : ""
            );
            setValue(
                "estimated_date",
                res?.data?.estimated_date ? moment(d.estimated_date).format("MM/DD/YYYY") : null,
            );
            setValue("contractOfficerName", d?.orderKo?.name || "");
            setValue("contractOfficerEmail", d?.orderKo?.email || "");
            setValue("contractOfficerPhone", d?.orderKo?.phone || "");
            setValue("contractOfficerAddress", d?.orderKo?.address || "");

            // Shipping — combine address parts
            const ship = d?.orderShipping || {};
            const fullShipAddress = [ship.address, ship.city, ship.state, ship.zip]
                .filter(Boolean)
                .join(", ");

            setValue("shippingCustomerName", ship?.name || "");
            setValue("shippingCustomerPhone", ship?.phone || "");
            setValue("shippingCustomerEmail", ship?.email || "");
            setValue("shippingCustomerAddress", fullShipAddress);

            setValue("totalCostAfterMargin", d?.total_cost_after_margin || "");

            // Products
            d?.OrderProductSales?.forEach((product, index) => {
                const rowId = generateUniqueId10();
                setValue(`product_sales[${index}].skuDescription`, product?.description || "");
                setValue(`product_sales[${index}].vendorPartner`, product?.Vendor?.display_name || "");
                setValue(`product_sales[${index}].skuIdUnique`, product?.sku_id || "");
                setValue(`product_sales[${index}].productId`, product?.product_id || "");
                setValue(`product_sales[${index}].type`, product?.type || "");
                // setValue(`product_sales[${index}].type`, product?.type || "");
                // setValue(`product_sales[${index}].rowId`, product?.raw_sku_id || "");
                setValue(`product_sales[${index}].vendorId`, product?.vendor_id || "");
                // setValue(`product_sales[${index}].productId`, product?.Product?.id || "");
                // setValue(`product_sales[${index}].clin`, product?.clin_id || "");
                setValue(
                    `product_sales[${index}].productName`,
                    product?.name ?? product?.Product?.name ?? ""
                );
                setValue(`product_sales[${index}].skuId`, product?.sku_display_name || "");
                setValue(
                    `product_sales[${index}].cost`,
                    trimTrailingZeros(product?.aspetto_price)
                );
                setValue(`product_sales[${index}].rowId`, rowId);

                const margin =
                    ((product?.customer_price - product?.aspetto_price) /
                        product?.customer_price) *
                    100;
                setValue(`product_sales[${index}].margin`, trimTrailingZeros(product?.margin) || 0);
                setValue(`product_sales[${index}].qty`, trimTrailingZeros(product?.quantity) || 0);
                setValue(`product_sales[${index}].max_quantity`, product?.max_quantity);
                // setValue(`product_sales[${index}].ordered_quantity`, product?.ordered_quantity || 0);
                setValue(`product_sales[${index}].um`, product?.unit_of_measure || "");
                setValue(`product_sales[${index}].customerCost`, product?.customer_price || "");
                setValue(`product_sales[${index}].totalSkuCost`, product?.total_price || "");
            });
        }
    };



    const onErrorUpload = (error) => {
        toast.error(error?.message || "Error uploading file.");
        console.error("Upload Error:", error);
    };

    const handleStartProcessing = async () => {
        if (!selectedFiles.length) return;

        const formData = new FormData();
        formData.append("pdf", selectedFiles[0]);

        await uploadPdf(formData, onSuccessUpload, onErrorUpload);
    };


    const {
        control,
        watch,
        setValue,
        register,
        formState: { errors },
    } = useFormContext();


    return (
         <Modal show={show} onHide={handleClose} size="lg" backdrop={uploading ? "static" : true} keyboard={!uploading}>
            <Modal.Header closeButton={!uploading}>
                <Modal.Title>Upload GSA PDF</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ position: "relative" }}>
                {uploading && (
                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            background: "rgba(255,255,255,0.75)",
                            zIndex: 10,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "0.3rem",
                        }}
                    >
                        <Spinner
                            animation="border"
                            role="status"
                            style={{ color: "#FE6338", width: "3rem", height: "3rem" }}
                        >
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                        <div className="mt-3 fw-semibold text-dark">
                            Processing PDF, please wait...
                        </div>
                    </div>
                )}

                <Card
                    className="border-0 shadow-sm mb-4"
                    style={{ borderRadius: "20px", padding: "30px 0" }}
                >
                    <div
                        className="w-50 d-flex flex-column align-items-center justify-content-center m-0 m-auto"
                        onClick={handleBrowseClick}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                        style={{
                            border: `2px dashed ${isDragging ? "#FE6338" : "#dee2e6"}`,
                            backgroundColor: isDragging ? "#fff5f0" : "transparent",
                            borderRadius: "20px",
                            padding: "40px",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                        }}
                    >
                        <div className="mb-3">
                            <IconCloudUp size={40} color={isDragging ? "#FE6338" : "#6C7A91"} />
                        </div>
                        <h5 className="fw-bold mb-1">
                            {isDragging ? "Drop files here" : "Click or drag PDF files here"}
                        </h5>
                        <p className="text-muted small mb-4">
                            Supports PDF files (Max 20MB each)
                        </p>

                        <input
                            type="file"
                            accept=".pdf"
                            hidden
                            ref={fileInputRef}
                            onChange={handleFileChange}
                        />
                        <Button
                            onClick={(e) => {
                                e.stopPropagation();
                                handleBrowseClick();
                            }}
                            style={{
                                backgroundColor: "#191d26",
                                border: "none",
                                padding: "10px 30px",
                                borderRadius: "8px",
                                fontWeight: "bold",
                            }}
                        >
                            Browse Files
                        </Button>
                    </div>

                    {selectedFiles.length > 0 && (
                        <div className="w-50 m-0 m-auto mt-3">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="d-flex align-items-center gap-2">
                                    <h6 className="mb-0 fw-bold">
                                        Selected Files ({selectedFiles.length})
                                    </h6>
                                </div>
                                <Button
                                    variant="link"
                                    className="text-danger text-decoration-none p-0 fw-bold"
                                    onClick={handleClearAll}
                                    disabled={uploading}
                                >
                                    Clear All
                                </Button>
                            </div>

                            {selectedFiles.map((file, index) => (
                                <div
                                    key={index}
                                    className="d-flex align-items-center gap-3 p-3 mb-3"
                                    style={{
                                        backgroundColor: "#f8faff",
                                        borderRadius: "12px",
                                        border: "1px solid #edf2f7",
                                    }}
                                >
                                    <div className="p-2 bg-white border rounded">
                                        <IconFileText size={20} color="#adb5bd" />
                                    </div>
                                    <div>
                                        <div
                                            className="fw-medium text-dark"
                                            style={{ fontSize: "0.9rem" }}
                                        >
                                            {file.name}
                                        </div>
                                        <div
                                            className="text-muted"
                                            style={{ fontSize: "0.75rem" }}
                                        >
                                            {(file.size / (1024 * 1024)).toFixed(2)} MB
                                        </div>
                                    </div>
                                </div>
                            ))}

                            <Button
                                className="w-100 mt-2 py-3 d-flex align-items-center justify-content-center gap-2"
                                style={{
                                    backgroundColor: "#FE6338",
                                    border: "none",
                                    borderRadius: "12px",
                                    fontSize: "1.1rem",
                                    fontWeight: "600",
                                }}
                                onClick={handleStartProcessing}
                                disabled={uploading}
                            >
                                {uploading ? (
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                        Submitting...
                                    </>
                                ) : (
                                    <>
                                        Submit <IconArrowRight size={20} />
                                    </>
                                )}
                            </Button>
                        </div>
                    )}
                </Card>
            </Modal.Body>
        </Modal>
    );
}

export default GsaPdfModal;